import React from 'react'

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const TableSkeleton = ({
  rows = 6,
  columns = [],
  rowClassName = "flex gap-4 items-center mb-4",
  wrapperClassName = "p-6"
}) => {
  return (
    <div className={wrapperClassName}>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <div className={rowClassName} key={rowIndex}>
          {columns.map((width, colIndex) => (
            <Skeleton
              key={colIndex}
              height={20}
              width={width}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

export default TableSkeleton;
